'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = PlanLevelFree;

require('./plan-level-free.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function PlanLevelFree(props) {

    var url = '/info/chooseFreeOrEnterpriseSignupPlan';

    var buttonProps = {
        buttonText: 'Start Free Plan',
        buttonColor: 'ashen',
        buttonHoverColor: 'cerulean',
        buttonLink: url
    };

    return _react2['default'].createElement(
        'div',
        { className: 'm-plan-level-free columns small-12 medium-12 large-12' },
        _react2['default'].createElement(
            'div',
            { className: 'level-title free-title large-3 columns block' },
            _react2['default'].createElement(
                'div',
                { className: 'in' },
                'Free'
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'large-6 free-blurb columns block' },
            'Just need to sign a document? Try our ',
            _react2['default'].createElement(
                'strong',
                null,
                'FREE'
            ),
            ' plan.'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'large-3 free-button columns block' },
            _react2['default'].createElement(_button2['default'], buttonProps)
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/plan-level-free.jsx
 ** module id = 1148
 ** module chunks = 0
 **/